import React, { useEffect, useState } from 'react'
import HeaderBanner from '../../components/header-banner/HeaderBanner'
import DonneesSolList from '../../components/DonneesSolList/DonneesSolList'
import Footer from '../../components/footer/Footer'
import client from '../../client/Client'
import EventsSlider from '../../components/EventsSlider/EventsSlider'

const DonneesEtSol = () => {
  const [selectedSection, setSelectedSection] = useState("donnees");
  const [myData, setMyData] = useState([])
  useEffect(() => {
    if(selectedSection === "donnees") {
      client.fetch('*[_type == "donnees"]')
      .then((result) => {
        setMyData(result)
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
    }
    else{
      client.fetch('*[_type == "solution"]')
      .then((result) => {
      setMyData(result)
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
    }
  }, [selectedSection])
  const [events, setEvents] = useState([])
  useEffect(() => {
    client.fetch('*[_type == "event"]')
    .then((result) => {
      setEvents(result)
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
  }, [])
  return (
    <div>
        <HeaderBanner title={"Données"} colored={"& Solutions"} isHome={false} />
        <DonneesSolList selectedSection={selectedSection} myData={myData} setSelectedSection={setSelectedSection} />
        {/* <EventsSlider events={events} /> */}
        <Footer />

    </div>
  )
}

export default DonneesEtSol